export const UpdateOrganization = `mutation updateOrganization($organizationid: ID!, $name: String!, $updatedby: ID!, $isverified: Boolean, $locationid: ID, $orgphonenumber: String, $orgemail: String, $categories: [String], $employeesize: String, $yearsinbusiness: Int, $revenue: String, $businessstartdate: String, $orgtwitter: String, $orgmap: String, $typeofentity: String, $orgwebsite: String, $orgfacebook: String, $orgstatus: Int, $orgtags: [String!], $orgsource: [String!], $orgownerid: ID, $orglinkedin: String, $orggmb: String, $orgyelp: String, $orgtripadvisor: String, $contactid: ID, $shortdesc: String, $longdesc: String, $businesslogo: String, $images: [String], $availablehours: [InputAvailableHours], $uploadlogo: Upload, $uploadimages: [Upload], $orgyoutubeurl: String, $orgattribute1: String, $orgattribute2: String, $orgattribute3: String, $orgattribute4: String, $orgattribute5: String, $orgattribute6: String, $orgattribute7: String, $orgattribute8: String, $orgattribute9: String, $orgattribute10: String, $orgattribute11: String, $orgattribute12: String, $orgattribute13: String, $orgattribute14: String, $orgattribute15: String, $orgattribute16: String, $orgattribute17: String, $orgattribute18: String, $orgattribute20: String, $orgattribute21: String, $orgattribute19: String, $orgattribute22: String, $orgattribute23: String, $orgattribute24: String, $orgattribute25: String, $orgattribute26: String, $orgattribute27: String, $orgattribute28: String, $orgattribute29: String, $phonecountryid: ID, $orgattribute50: String, $orgattribute49: String, $orgattribute48: String, $orgattribute47: String, $orgattribute46: String, $orgattribute45: String, $orgattribute44: String, $orgattribute43: String, $orgattribute42: String, $orgattribute41: String, $orgattribute40: String, $orgattribute39: String, $orgattribute38: String, $orgattribute37: String, $orgattribute36: String, $orgattribute35: String, $orgattribute34: String, $orgattribute33: String, $orgattribute32: String, $orgattribute31: String, $orgattribute30: String) {
    updateOrganization(organizationid: $organizationid, name: $name, updatedby: $updatedby, locationid: $locationid,
       orgphonenumber: $orgphonenumber, isverified: $isverified, orgemail: $orgemail, categories: $categories, employeesize: $employeesize, yearsinbusiness: $yearsinbusiness, revenue: $revenue, businessstartdate: $businessstartdate, orgtwitter: $orgtwitter, orgmap: $orgmap, typeofentity: $typeofentity, orgwebsite: $orgwebsite, orgfacebook: $orgfacebook, orgstatus: $orgstatus, orgtags: $orgtags, orgsource: $orgsource, orgownerid: $orgownerid, orglinkedin: $orglinkedin, orggmb: $orggmb, orgyelp: $orgyelp, orgtripadvisor: $orgtripadvisor, contactid: $contactid, shortdesc: $shortdesc, longdesc: $longdesc, businesslogo: $businesslogo, images: $images, availablehours: $availablehours, uploadlogo: $uploadlogo, uploadimages: $uploadimages, orgyoutubeurl: $orgyoutubeurl, orgattribute1: $orgattribute1, orgattribute2: $orgattribute2, orgattribute3: $orgattribute3, orgattribute4: $orgattribute4, orgattribute5: $orgattribute5, orgattribute6: $orgattribute6, orgattribute7: $orgattribute7, orgattribute8: $orgattribute8, orgattribute9: $orgattribute9, orgattribute10: $orgattribute10, orgattribute11: $orgattribute11, orgattribute12: $orgattribute12, orgattribute13: $orgattribute13, orgattribute14: $orgattribute14, orgattribute15: $orgattribute15, orgattribute16: $orgattribute16, orgattribute17: $orgattribute17, orgattribute18: $orgattribute18, orgattribute20: $orgattribute20, orgattribute21: $orgattribute21, orgattribute19: $orgattribute19, orgattribute22: $orgattribute22, orgattribute23: $orgattribute23, orgattribute24: $orgattribute24, orgattribute25: $orgattribute25, orgattribute26: $orgattribute26, orgattribute27: $orgattribute27, orgattribute28: $orgattribute28, orgattribute29: $orgattribute29, phonecountryid: $phonecountryid, orgattribute50: $orgattribute50, orgattribute49: $orgattribute49, orgattribute48: $orgattribute48, orgattribute47: $orgattribute47, orgattribute46: $orgattribute46, orgattribute45: $orgattribute45, orgattribute44: $orgattribute44, orgattribute43: $orgattribute43, orgattribute42: $orgattribute42, orgattribute41: $orgattribute41, orgattribute40: $orgattribute40, orgattribute39: $orgattribute39, orgattribute38: $orgattribute38, orgattribute37: $orgattribute37, orgattribute36: $orgattribute36, orgattribute35: $orgattribute35, orgattribute34: $orgattribute34, orgattribute33: $orgattribute33, orgattribute32: $orgattribute32, orgattribute31: $orgattribute31, orgattribute30: $orgattribute30)
  }`;

export const OrganizationData = `query Organization($organizationid: ID!) {
    organization(organizationid: $organizationid) {
      organizationid
      name
      locationid
      orgphonenumber
      orgemail
      categories
      employeesize
      yearsinbusiness
      revenue
      businessstartdate
      typeofentity
      orgmap
      orgwebsite
      orgtwitter
      orgfacebook
      orgstatus
      orgtags
      orgsource
      orgownerid
      orglinkedin
      orggmb
      orgyelp
      isverified
      orgtripadvisor
      createdby
      updatedby
      phonecountryid
      createdAt
      updatedAt
      shortdesc
      longdesc
      orgyoutubeurl
      orgattribute1
      orgattribute2
      orgattribute3
      orgattribute4
      orgattribute5
      orgattribute6
      orgattribute7
      orgattribute8
      orgattribute9
      orgattribute10
      orgattribute11
      orgattribute12
      orgattribute13
      orgattribute14
      orgattribute15
      orgattribute16
      orgattribute17
      orgattribute18
      orgattribute19
      orgattribute20
      orgattribute21
      orgattribute22
      orgattribute23
      orgattribute24
      orgattribute25
      orgattribute26
      orgattribute27
      orgattribute28
      orgattribute29
      orgattribute30
      orgattribute31
      orgattribute32
      orgattribute33
      orgattribute34
      orgattribute35
      orgattribute36
      orgattribute37
      orgattribute38
      orgattribute39
      orgattribute40
      orgattribute41
      orgattribute42
      orgattribute43
      orgattribute44
      orgattribute45
      orgattribute46
      orgattribute47
      orgattribute48
      orgattribute49
      orgattribute50
    }
  }`;

export const ContactsByOrganization = `query ContactsByOrganization($organizationid: ID!) {
  contactsByOrganization(organizationid: $organizationid) {
    contactid
    firstname
    jobid
    lastname
    phonenumber
    primaryemail
  }
}`;

export const CreateOrganization = `mutation createOrganization($name: String!, $locationid: ID!, $createdby: ID!, $orgphonenumber: String, $orgemail: String, $categories: [String], $employeesize: String, $businessstartdate: String, $revenue: String, $yearsinbusiness: Int, $typeofentity: String, $orgmap: String, $orgwebsite: String, $orgfacebook: String, $orgtwitter: String, $orgstatus: Int, $orglinkedin: String, $orggmb: String, $orgyelp: String, $orgtripadvisor: String, $contactid: ID, $orgtags: [String!], $orgsource: [String!], $orgownerid: ID, $orgyoutubeurl: String, $phonecountryid: ID, $shortdesc: String, $longdesc: String, $businesslogo: String, $images: [String], $availablehours: [InputAvailableHours], $uploadlogo: Upload, $uploadimages: [Upload], $orgattribute2: String, $orgattribute1: String, $orgattribute3: String, $orgattribute4: String, $orgattribute5: String, $orgattribute6: String, $orgattribute9: String, $orgattribute7: String, $orgattribute8: String, $orgattribute10: String, $orgattribute11: String, $orgattribute12: String, $orgattribute14: String, $orgattribute15: String, $orgattribute13: String, $orgattribute16: String, $orgattribute17: String, $orgattribute18: String, $orgattribute19: String, $orgattribute20: String, $orgattribute21: String, $orgattribute22: String, $orgattribute23: String, $orgattribute24: String, $orgattribute25: String, $orgattribute26: String, $orgattribute27: String, $orgattribute29: String, $orgattribute30: String, $orgattribute28: String, $orgattribute33: String, $orgattribute32: String, $orgattribute31: String, $orgattribute34: String, $orgattribute36: String, $orgattribute35: String, $orgattribute37: String, $orgattribute38: String, $orgattribute39: String, $orgattribute40: String, $orgattribute41: String, $orgattribute42: String, $orgattribute43: String, $orgattribute44: String, $orgattribute45: String, $orgattribute46: String, $orgattribute47: String, $orgattribute48: String, $orgattribute49: String, $orgattribute50: String) {
  createOrganization(name: $name, locationid: $locationid, createdby: $createdby, orgphonenumber: $orgphonenumber, orgemail: $orgemail,
     categories: $categories, employeesize: $employeesize, businessstartdate: $businessstartdate, revenue: $revenue, yearsinbusiness: $yearsinbusiness, typeofentity: $typeofentity, orgmap: $orgmap, orgwebsite: $orgwebsite, orgfacebook: $orgfacebook, orgtwitter: $orgtwitter, orgstatus: $orgstatus, orglinkedin: $orglinkedin, orggmb: $orggmb, orgyelp: $orgyelp, orgtripadvisor: $orgtripadvisor, contactid: $contactid, orgtags: $orgtags, orgsource: $orgsource, orgownerid: $orgownerid, orgyoutubeurl: $orgyoutubeurl, phonecountryid: $phonecountryid, shortdesc: $shortdesc, longdesc: $longdesc, businesslogo: $businesslogo, images: $images, availablehours: $availablehours, uploadlogo: $uploadlogo, uploadimages: $uploadimages, orgattribute2: $orgattribute2, orgattribute1: $orgattribute1, orgattribute3: $orgattribute3, orgattribute4: $orgattribute4, orgattribute5: $orgattribute5, orgattribute6: $orgattribute6, orgattribute9: $orgattribute9, orgattribute7: $orgattribute7, orgattribute8: $orgattribute8, orgattribute10: $orgattribute10, orgattribute11: $orgattribute11, orgattribute12: $orgattribute12, orgattribute14: $orgattribute14, orgattribute15: $orgattribute15, orgattribute13: $orgattribute13, orgattribute16: $orgattribute16, orgattribute17: $orgattribute17, orgattribute18: $orgattribute18, orgattribute19: $orgattribute19, orgattribute20: $orgattribute20, orgattribute21: $orgattribute21, orgattribute22: $orgattribute22, orgattribute23: $orgattribute23, orgattribute24: $orgattribute24, orgattribute25: $orgattribute25, orgattribute26: $orgattribute26, orgattribute27: $orgattribute27, orgattribute29: $orgattribute29, orgattribute30: $orgattribute30, orgattribute28: $orgattribute28, orgattribute33: $orgattribute33, orgattribute32: $orgattribute32, orgattribute31: $orgattribute31, orgattribute34: $orgattribute34, orgattribute36: $orgattribute36, orgattribute35: $orgattribute35, orgattribute37: $orgattribute37, orgattribute38: $orgattribute38, orgattribute39: $orgattribute39, orgattribute40: $orgattribute40, orgattribute41: $orgattribute41, orgattribute42: $orgattribute42, orgattribute43: $orgattribute43, orgattribute44: $orgattribute44, orgattribute45: $orgattribute45, orgattribute46: $orgattribute46, orgattribute47: $orgattribute47, orgattribute48: $orgattribute48, orgattribute49: $orgattribute49, orgattribute50: $orgattribute50) {
    organizationid
    name
    locationid
    orgphonenumber
    orgemail
    categories
    employeesize
    yearsinbusiness
    revenue
    businessstartdate
    typeofentity
    orgmap
    orgwebsite
    orgtwitter
    orgfacebook
    orgstatus
    orgtags
    orgsource
    orgownerid
    orglinkedin
    orggmb
    orgyelp
    orgtripadvisor
    createdby
    updatedby
    phonecountryid
    createdAt
    updatedAt
    contactcount
    shortdesc
    longdesc
    businesslogo
    images
    isverified
    orgyoutubeurl
    orgattribute1
    orgattribute2
    orgattribute3
    orgattribute4
    orgattribute5
    orgattribute6
    orgattribute7
    orgattribute8
    orgattribute9
    orgattribute10
    orgattribute11
    orgattribute12
    orgattribute13
    orgattribute14
    orgattribute15
    orgattribute16
    orgattribute17
    orgattribute18
    orgattribute19
    orgattribute20
    orgattribute21
    orgattribute22
    orgattribute23
    orgattribute24
    orgattribute25
    orgattribute26
    orgattribute27
    orgattribute28
    orgattribute29
    orgattribute30
    orgattribute31
    orgattribute32
    orgattribute33
    orgattribute34
    orgattribute35
    orgattribute36
    orgattribute37
    orgattribute38
    orgattribute39
    orgattribute40
    orgattribute41
    orgattribute42
    orgattribute43
    orgattribute44
    orgattribute45
    orgattribute46
    orgattribute47
    orgattribute48
    orgattribute49
    orgattribute50
  }
}`;

export const OrganizationByContactId = `
query organizationByContactid($contactid: ID!){
    organizationByContactid(contactid: $contactid){
        organizationid
        name
        locationid
        phonenumber
        website
        twitter
        facebook
        status
        linkedin
        gmb
        address{
            addressid,
            street1,
            street2,
            city,
            stateid,
            state,
            addresstype,
            countryid,
            zip
        }
        yelp
        tripadvisor
        createdby
        updatedby
        phonecountryid
        createdAt
        updatedAt
    }
}`;
